
import { defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import ServiceNav from '../../../components/Service/ServiceNav.vue';

export default defineComponent({
  name: 'Service',
  components: { ServiceNav },
  setup() {
    const store = useStore();
    const toHome = () => {
      store.commit('changeActiveHead', 'main');
    };
    return {
      toHome,
    };
  },
});
